import { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import { Plus, Trash2, Save } from "lucide-react";
import { AdminHeader } from "@/pages/admin/AdminLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";

export default function Promotions() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => { api.get("/admin/promotions").then((r) => setItems(r.data || [])).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  const add = async () => { await api.post("/admin/promotions", { title: "New Promotion", body: "", type: "banner", enabled: false, order: items.length + 1 }); load(); };
  const save = async (p) => { try { await api.put(`/admin/promotions/${p.id}`, p); toast.success("Saved"); load(); } catch { toast.error("Save failed"); } };
  const del = async (id) => { if (!window.confirm("Delete promotion?")) return; await api.delete(`/admin/promotions/${id}`); load(); };
  const setField = (i, k, v) => setItems((arr) => arr.map((x, j) => j === i ? { ...x, [k]: v } : x));

  return (
    <div data-testid="admin-promotions">
      <AdminHeader title="Promotions" subtitle="Banners, seasonal blocks, and homepage specials"
        action={<Button onClick={add} className="bg-mtm-purple hover:bg-mtm-purple-deep text-white rounded-full" data-testid="add-promotion-button"><Plus size={16} /> Add Promotion</Button>} />
      <div className="space-y-4">
        {items.map((p, i) => (
          <div key={p.id} className="bg-white rounded-xl border border-slate-200 p-6 space-y-3" data-testid={`promo-${p.id}`}>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <div className="md:col-span-2"><Label className="text-xs">Title</Label><Input value={p.title ?? ""} onChange={(e) => setField(i, "title", e.target.value)} /></div>
              <div><Label className="text-xs">Type</Label>
                <Select value={p.type || "banner"} onValueChange={(v) => setField(i, "type", v)}><SelectTrigger><SelectValue /></SelectTrigger><SelectContent>
                  <SelectItem value="banner">Banner</SelectItem><SelectItem value="seasonal">Seasonal Block</SelectItem><SelectItem value="coming_soon">Coming Soon</SelectItem><SelectItem value="special">Homepage Special</SelectItem>
                </SelectContent></Select>
              </div>
            </div>
            <div><Label className="text-xs">Body</Label><Textarea rows={2} value={p.body ?? ""} onChange={(e) => setField(i, "body", e.target.value)} /></div>
            <div className="flex items-center gap-4">
              <label className="flex items-center gap-2 text-sm"><Switch checked={!!p.enabled} onCheckedChange={(v) => setField(i, "enabled", v)} /> Enabled</label>
              <Button onClick={() => save(items[i])} className="bg-mtm-purple text-white rounded-full"><Save size={15} /> Save</Button>
              <Button variant="outline" onClick={() => del(p.id)} className="border-red-200 text-red-600 rounded-full"><Trash2 size={15} /></Button>
            </div>
          </div>
        ))}
        {!items.length && <div className="bg-white rounded-xl border border-slate-200 p-10 text-center text-slate-400">No promotions yet.</div>}
      </div>
    </div>
  );
}
